import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class FileUploadComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentFileUpload | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.disabled = settings?.disabled ?? false;
		this.fileMinSize = settings?.fileMinSize ?? 0;
		this.fileMaxSize = settings?.fileMaxSize;
		this.filePattern = settings?.filePattern ?? '*';
		this.image = settings?.image ?? false;
		this.imageSize = settings?.imageSize ?? 200;
		this.input = false;
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.validate = {
			card: new Card(settings?.validate?.card ?? '0-1'),
		};
	}
}
